"use client";
import { UpgradeBanner } from "@/components/ui/upgrade-banner";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

const RotatingUpgradeBanners = () => {
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const router = useRouter();

  // Define the 5 different banner contents
  const banners = [
    {
      startText: "Track applications for free with",
      buttonText: "JobTracker AI",
      description: "",
      path: "/features/jobtracker-ai",
    },
    {
      startText: "Build ATS-proof resumes using",
      buttonText: "Smart Resume Builder",
      description: "",
      path: "/features/smart-resume-builder",
    },
    {
      startText: "Message hiring managers via",
      buttonText: "Insider Connections",
      description: "",
      path: "/features/insider-connections",
    },
    {
      startText: "Practice interviews using",
      buttonText: "AI Mock Interview",
      description: "",
      path: "/features/ai-mock-interview",
    },
    {
      startText: "Generate letters instantly with",
      buttonText: "Cover Letter Copilot",
      description: "",
      path: "/features/cover-letter-copilot",
    },
  ];

  // Auto-rotate banners every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBannerIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Handle click and close functions
  const handleOnClick = (path: string) => {
    router.push(path);
  };

  const handleOnClose = () => {
    // Move to the next banner when closed
    setCurrentBannerIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  const currentBanner = banners[currentBannerIndex] as any;

  return (
    <div className="w-full">
      <UpgradeBanner
        startText={currentBanner?.startText}
        buttonText={currentBanner?.buttonText}
        description={currentBanner?.description}
        bannerKey={currentBannerIndex}
        onClose={handleOnClose}
        onClick={() => handleOnClick(currentBanner?.path as string)}
      />

      {/* Banner indicator dots */}
      {/* <div className="flex justify-center space-x-2 pb-2">
        {banners.map((_, index) => (
          <button
            key={index}
            className={`h-2 w-2 rounded-full ${
              index === currentBannerIndex ? "bg-green-600" : "bg-gray-300"
            }`}
            onClick={() => setCurrentBannerIndex(index)}
          />
        ))}
      </div> */}
    </div>
  );
};

export default RotatingUpgradeBanners;
